<ng-container *ngIf="data.policyType === 'HO3'">
    <div class="popup1">
      <mat-icon mat-dialog-close class="close">close</mat-icon>
      <p><strong>What’s an HO3 Policy?</strong></p>
      <p>An HO3 policy is the most common type of home insurance, but it’s not the right fit for every situation.</p>
      <ul class="policy-list">
        <li>HO3 insurance is the most common type of home insurance policy.</li>
        <li>Standard HO3 policies provide coverage for your home’s structure, contents, liability, medical payments and additional living expenses.</li>
        <li>Standard HO3 policies exclude damage from flooding and earthquakes, but coverage may be available through endorsements or standalone policies.</li>
      </ul>
    </div>
  </ng-container>
  
  <ng-container *ngIf="data.policyType === 'HO6'">
    <div class="popup1">
      <mat-icon mat-dialog-close class="close">close</mat-icon>
      <p><strong>What’s an HO6 Policy?</strong></p>
      <p>An HO6 policy, also known as condo insurance, provides coverage for condo owners, covering the interior of their unit, personal property, and liability, but not the building's exterior or common areas. </p>
      <ul class="policy-list">
        <li>Interior of the condo unit:</li>
        <p>This includes things like walls, floors, and fixtures, but not the building's structure.</p>
        <li>Personal property:</li>
        <p>This covers your belongings, such as furniture, clothing, electronics, and other personal items within the condo.</p>
        <li>Loss assessment coverage:</li>
        <p>This helps cover you when you are responsible for additional costs shared by the condo association not covered by their insurance policy.</p>
        <li>Liability coverage:</li>
        <p>This protects you from legal costs if someone is injured on your property or if you damage someone else's property.</p>
        <li>Additional living expenses:</li>
        <p>This helps cover the costs of lodging and other living expenses if your unit is rendered uninhabitable by a covered cause of loss.</p>
      </ul>
    </div>
  </ng-container>
  
    <ng-container *ngIf="data.policyType === 'DP3'">
    <div class="popup1">
      <mat-icon mat-dialog-close class="close">close</mat-icon>
      <p><strong>What’s a DP3 Policy?</strong></p>
      <p>A DP3 policy, also known as the Special Form Dwelling Property, is a more comprehensive insurance option for rental dwelling properties. </p>
      <ul class="policy-list">
        <li>DP3 policies provide coverage for the home’s structure against a wide range of risks, including fire, wind, hail, vandalism, and more.</li>
        <li>They also include protection for damage caused by burglars, falling objects, the weight of ice, snow, or sleet, and accidental discharge or overflow of water or steam.</li>
        <li>Additional covered events include sudden cracking of a hot water or steam system, freezing, and sudden damage from electrical surges.</li>
      </ul>
    </div>
  </ng-container>

    <ng-container *ngIf="data.policyType === 'DP1'">
    <div class="popup1">
      <mat-icon mat-dialog-close class="close">close</mat-icon>
      <p><strong>What’s a DP1 Policy?</strong></p>
      <p>A DP1 policy, also known as a Basic Form Dwelling Property policy, is a straightforward insurance option for rental dwelling properties. </p>
      <ul class="policy-list">
        <li>DP1 policies provide named-peril coverage, meaning they only cover risks that are specifically listed in the policy.</li>
        <li>By default, those perils are limited to fire or lightning and internal explosion. Other coverages, like windstorm, vandalism, or smoke, are available as optional endorsements, but are not included in the standard policy.</li>
        <li>This policy type offers a more affordable alternative to broader coverage forms, but with more limited protection.</li>
      </ul>
    </div>
  </ng-container>